import React, {Fragment} from 'react';
import {
    Card,
    Table,
    Menu,
    Dropdown,
    Space,
    Input,
    Row,
    Button,
    Typography,
    Modal,
    Form,
    Select,
    Checkbox,
    TimePicker,
    InputNumber,
    notification,
    Spin, Steps, Divider, DatePicker, Switch, Collapse, AutoComplete
} from "antd";

import {
    DownOutlined,
    DownloadOutlined,
    DeleteOutlined,
    PlusOutlined,
    EuroCircleOutlined,
    LinkOutlined,
    MinusOutlined
} from '@ant-design/icons';

import ApiService from "../services/ApiService"

import {API_BASE_URL} from "../configs/AppConfig";
import ModalPromesse from "./ModalPromesse";
import moment from 'moment'

import MultiAssocForm2 from "../components/custom-fields/MultiAssocForm2";
import PermissionAlert from "../components/permissions/PermissionAlert";
import ContactIcon from "../components/util-components/ContactIcon";
import ImageUploadField from "../components/custom-fields/ImageUpload";
import {getCountry, getDeviseSymbol} from "../components/permissions/functions";
import COUNTRY from "country-json/src/country-by-abbreviation.json";
import {connect} from "react-redux";

import {t} from "@lingui/core/macro"
import {Trans} from "@lingui/react/macro"
import { translateLivretType } from '../views/app-views/paiements/functions';

const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


class ModalBasePaiement extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    fields = ["contact_nom", "contact_prenom", "tel", "email", "nom", "prenom", "adresse", "ville", "postal", "pays", "raison", "siren"]

    resetAllFields() {
        this.formInfo.resetFields(this.fields)
    }

    initstate = {
        visible: false,
        loading: false,
        info: null,
        facturation: {perso: true},
        types: [],
        type: null,
        step: 0,
        contacts: [],
        contact: null,
        defaultData: {pays: "France"},
        showContactSelect: false,
        assoc:"MAIN",
        disableAssoc:false,
        noContactType:false,
    };

    state = this.initstate

    callback=null

    async show(contact = null,callback,defaultState={}) {
        this.callback=callback;
        console.log("ModalBasePaiement ",contact)

        if (contact) {
            var finalContact = {...contact, contact_nom: contact.nom, contact_prenom: contact.prenom}
            if (!finalContact.pays) {
                finalContact.pays = COUNTRY.find(i=>i.abbreviation===getCountry())?.country
            }
            this.setState({...defaultState,visible: true, contact: {...finalContact}, defaultData: {...finalContact}})
        } else {
            this.setState({...defaultState,visible: true, showContactSelect: true}, () => this.getContacts())
        }

        await this.getTypes()
    }

    async showWithType(contact = null, type,callback) {
        this.callback=callback;
        console.log("PAYEMENT Type ", type)
        await this.getContacts()

        var finalContact = null
        if (contact) {
            finalContact = {...contact, contact_nom: contact.nom, contact_prenom: contact.prenom}
            if (!finalContact.pays) {
                finalContact.pays = COUNTRY.find(i=>i.abbreviation===getCountry())?.country
            }
        }



        this.setState({
            contact: finalContact,
            defaultData: finalContact,
            showContactSelect: true
        }, () => {

            this.getTypes(() => {
                console.log(this.state.types, type)
                console.log(this.state.types.find(i => i.value === type))
                this.setState({visible: true, type: this.state.types.find(i => i.value === type)})
            })

        })

    }

    async getTypes(callback = null)
    {
        let params={}
        if(!this.state.noContactType){
            params={contact: this.state.contact?.id}
        }

        var res2 = await ApiService.get("/paiements/cerfa/types/", params)
        console.log(res2)
        this.setState({types: res2.items}, () => {
            if (callback) {
                callback()
            }
        })
    }

    async getContacts() {
        var res = await ApiService.get("/contact/form?withAdresse=1")
        this.setState({contacts: res.data})
    }

    getAdresses() {
        var contact = this.state.contact
        if (!contact) {
            return []
        }

        var adresses = [{
            id: "MAIN",
            name: t`Adresse Principale`,
            siren: null,
            adresse: contact.adresse,
            postal: contact.postal,
            ville: contact.ville,
            pays: contact.pays || "France"
        }]

        if (Array.isArray(contact.adresses) && contact.adresses.length > 0) {
            for (var item of contact.adresses) {
                adresses.push({
                    id: item.id,
                    name: item.nom,
                    siren: item.siren,
                    adresse: item.adresse,
                    postal: item.postal,
                    ville: item.ville,
                    pays: item.pays || "France"
                })
            }
        }

        return adresses
    }

    close() {
        this.callback=null
        this.setState(this.initstate)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.contact != this.state.contact && this.state.contact) {
            this.getTypes()
        }
    }

    async onFinish() {

        if ((!this.state.type && !this.props.onlyContact) || this.state.loading) {
            return false
        }

        this.setState({loading: true})

        var config = {
            info: this.state.info,
            facturation: this.state.facturation,
            assoc: this.state.assoc || "MAIN",
        }

        if(this.state.type){
            config.typeData=this.state.type
            config.type=this.state.type.type
            config.typeId=this.state.type.value
        }

        if (this.state.contact) {
            config.contact = this.state.contact.id
        }

        if (config?.type == "SERVICE") {
            config.service = this.state.type.data
        }

        if (this.callback) {
            this.callback(config)
        }
        this.close()

    }


    getFilteredTypes(types)
    {
        const assocInfo=this.props.org.cerfasInfos.find(i=>i.id===(this.state.assoc || "MAIN"))

        types=types.filter(i=>{
            if(i?.data?.devise && i.data?.devise!==assocInfo?.devise){
                return false
            }
            return true

        }).filter(i=>i.type!=="DETTE")

        return types
    }


    render() {

        var adresses = this.getAdresses()


        return (

            <Fragment>
                <Modal width={"100%"} style={{minHeight: 500}} title={this.props.title}
                       open={this.state.visible} destroyOnClose closable footer={null} onCancel={() => this.close()}>
                    <PermissionAlert permissions={["paiement.add"]}>

                        <Steps current={this.state.step} status={this.state.loading ? "wait" : "process"}>
                            <Steps.Step title={t`Informations`}
                                        description={this.state.info ? this.state.info.nom + " " + this.state.info.prenom : null}/>
                            <Steps.Step title={t`Raison`} description={this.state.type ? translateLivretType(this.state.type) : null}/>
                        </Steps>

                        {this.state.step == 0 && (
                            <div style={{marginTop:20}}>
                                <Form
                                    ref={(ref) => this.formInfo = ref}
                                    initialValues={this.state.defaultData}
                                    onFinish={(data) => {
                                        console.log(data)

                                        const info = {
                                            nom: data.contact_nom,
                                            prenom: data.contact_prenom,
                                            email: data.email,
                                            tel: null
                                        }

                                        if (data.tel) {
                                            info.tel = data.tel
                                        }

                                        var facturation = {}

                                        if (this.state.facturation.perso) {
                                            facturation = {
                                                perso: true,
                                                nom: data.nom,
                                                prenom: data.prenom,
                                                adresse: data.adresse,
                                                postal: data.postal,
                                                ville: data.ville,
                                                pays: data.pays,
                                            }
                                        } else {
                                            facturation = {
                                                perso: false,
                                                raison: data.raison,
                                                siren: data.siren,
                                                adresse: data.adresse,
                                                postal: data.postal,
                                                ville: data.ville,
                                                pays: data.pays,
                                            }
                                        }

                                        let newState={
                                            facturation: facturation,
                                            info: info,
                                        }

                                        if (!this.state.type && !this.props.onlyContact) {
                                            newState.step=1
                                        }

                                        if(data.assoc) {
                                            newState.assoc=data.assoc
                                        }

                                        this.setState(newState,()=>{
                                            if (this.state.type || this.props.onlyContact) {
                                                this.onFinish()
                                            }
                                        })
                                    }}
                                >

                                    {!this.state.disableAssoc &&(
                                        <MultiAssocForm2 devise={this.state.defaultData?.devise || this.state.type?.data?.devise}/>
                                    )}

                                    <Divider><Trans>Contact</Trans></Divider>

                                    {this.state.contact && !this.state.showContactSelect && (
                                        <div style={{marginBottom: 20}}>
                                            <Text><Trans>Contact:</Trans> {this.state.contact.prenom} {this.state.contact.nom}</Text>
                                        </div>
                                    )}

                                    {this.state.showContactSelect && this.state.contacts.length > 0 && (
                                        <div style={{marginBottom: 20}}>
                                            <Form.Item
                                                label={t`Choisir un Contact`}
                                            >
                                                <Select value={this.state.contact?.id} style={{minWidth: 300, marginRight: 5, marginBottom: 5}}
                                                        placeholder={t`Choisir un Contact`} showSearch
                                                        filterOption={(input, option) => {
                                                            var text = option.props.children
                                                            if (Array.isArray(text)) {
                                                                text = text.join("")
                                                            }
                                                            if(typeof text !== "string") {
                                                                return false
                                                            }
                                                            return text?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
                                                        }}
                                                        onChange={(id) => {
                                                            this.resetAllFields()
                                                            const contact = this.state.contacts.find(i => i.id == id)
                                                            if (contact) {
                                                                var finalContact = {
                                                                    ...contact,
                                                                    contact_nom: contact.nom,
                                                                    contact_prenom: contact.prenom
                                                                }
                                                                if (!finalContact.pays) {
                                                                    finalContact.pays = "France"
                                                                }
                                                                this.setState({contact: {...finalContact}})

                                                                Object.keys(finalContact).forEach((k) => {
                                                                    if (!Array.isArray(finalContact[k]) && typeof finalContact[k] !== 'object') {
                                                                        console.log(k, finalContact[k])
                                                                        this.formInfo.setFieldValue(k, finalContact[k])
                                                                    }
                                                                })
                                                            } else {
                                                                this.setState({contact: null})
                                                            }
                                                        }}
                                                >
                                                    <Select.Option value={"new"}><Trans>Nouveau Contact</Trans></Select.Option>

                                                    {this.state.contacts.map((item, index) => {
                                                        var telValue = ""
                                                        if (item.tel) {
                                                            telValue = "(" + item.tel + ")"
                                                        }

                                                        var emailValue = ""
                                                        if (item.email) {
                                                            emailValue = "(" + item.email + ")"
                                                        }

                                                        let adresses=[]
                                                        if(Array.isArray(item.adresses)){
                                                            adresses=item.adresses.filter(i=>!i.nom?.startsWith("Adresse")).map(i=>"["+i.nom+"]")
                                                        }

                                                        return <Select.Option key={index} value={item.id}><ContactIcon
                                                            contact={item}/> {item.prenom} {item.nom} {telValue} {emailValue} {adresses.join(" ")}
                                                        </Select.Option>
                                                    })}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    )}

                                    {adresses.length > 1 && (
                                        <div style={{marginBottom: 20}}>
                                            <Form.Item
                                                label={t`Choisir une Adresse`}
                                            >
                                                <Select style={{minWidth: 300, marginRight: 5, marginBottom: 5}}
                                                        placeholder={t`Choisir une Adresse`} onChange={(id) => {
                                                    this.resetAllFields()
                                                    const contact = this.state.contact
                                                    const item = adresses.find(i => i.id === id)

                                                    if (item) {
                                                        this.formInfo.setFieldValue("contact_nom", contact.nom)
                                                        this.formInfo.setFieldValue("contact_prenom", contact.prenom)

                                                        let tel = contact.tel
                                                        if (Array.isArray(contact.tels)) {
                                                            contact.tels.forEach(i => {
                                                                if (i.adresseId === id) {
                                                                    tel = i.number
                                                                }
                                                            })
                                                        }

                                                        let email = contact.email
                                                        if (Array.isArray(contact.emails)) {
                                                            contact.emails.forEach(i => {
                                                                if (i.adresseId === id) {
                                                                    email = i.email
                                                                }
                                                            })
                                                        }

                                                        this.formInfo.setFieldValue("tel", tel)
                                                        this.formInfo.setFieldValue("email", email)

                                                        this.setState({
                                                            facturation: {
                                                                ...this.state.facturation,
                                                                perso: item.siren ? false : true
                                                            }
                                                        })

                                                        if (item.siren) {
                                                            this.formInfo.setFieldValue("raison", item.name)
                                                            this.formInfo.setFieldValue("siren", item.siren)

                                                        } else {
                                                            this.formInfo.setFieldValue("nom", contact.nom)
                                                            this.formInfo.setFieldValue("prenom", contact.prenom)
                                                        }

                                                        this.formInfo.setFieldValue("adresse", item.adresse)
                                                        this.formInfo.setFieldValue("postal", item.postal)
                                                        this.formInfo.setFieldValue("ville", item.ville)
                                                        this.formInfo.setFieldValue("pays", item.pays)

                                                    } else {
                                                        this.setState({contact: null})
                                                    }
                                                }}>
                                                    {adresses.map((item, index) => {
                                                        return <Select.Option key={index} value={item.id}><Text
                                                            strong>{item.name} {item.siren && "(" + item.siren + ")"}</Text> {item.adresse} - {item.postal} {item.ville}
                                                        </Select.Option>
                                                    })}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    )}


                                    <Row>
                                        <Form.Item
                                            label={t`Prénom`}
                                            name="contact_prenom"
                                            style={{marginRight: 20}}
                                        >
                                            <Input placeholder={t`Prénom`}/>
                                        </Form.Item>

                                        <Form.Item
                                            label={t`Nom`}
                                            name="contact_nom"
                                            style={{marginRight: 20}}
                                        >
                                            <Input placeholder={t`Nom`}/>
                                        </Form.Item>

                                        <Form.Item
                                            label={t`Email`}
                                            name="email"
                                            style={{marginRight: 20}}
                                        >
                                            <AutoComplete style={{width: 200}} placeholder={t`Email`}>
                                                {this.state.contact && (
                                                    <Fragment>
                                                        {this.state.contact.email && (
                                                            <AutoComplete.Option
                                                                value={this.state.contact.email}>{this.state.contact.email}</AutoComplete.Option>
                                                        )}

                                                        {Array.isArray(this.state.contact.emails) && this.state.contact.emails.map(i => {
                                                            return (
                                                                <AutoComplete.Option
                                                                    value={i.email}>{i.type}: {i.email}</AutoComplete.Option>
                                                            )
                                                        })}
                                                    </Fragment>
                                                )}
                                            </AutoComplete>
                                        </Form.Item>

                                        <Form.Item
                                            label={t`Téléphone`}
                                            name="tel"
                                        >
                                            <AutoComplete style={{width: 200}} placeholder={t`Téléphone`}>
                                                {this.state.contact && (
                                                    <Fragment>
                                                        {this.state.contact.tel && (
                                                            <AutoComplete.Option
                                                                value={this.state.contact.tel}>{this.state.contact.tel}</AutoComplete.Option>
                                                        )}

                                                        {Array.isArray(this.state.contact.tels) && this.state.contact.tels.map(i => {
                                                            return (
                                                                <AutoComplete.Option
                                                                    value={i.number}>{i.type}: {i.number}</AutoComplete.Option>
                                                            )
                                                        })}
                                                    </Fragment>
                                                )}
                                            </AutoComplete>
                                        </Form.Item>
                                    </Row>

                                    <Divider><Trans>Adresse de Facturation</Trans></Divider>
                                    <Form.Item label={t`Particulier / Entreprise`}>
                                        <Switch checked={!this.state.facturation.perso}
                                                onChange={(v) => this.setState({facturation: {perso: !v}})}/>
                                    </Form.Item>

                                    {this.state.facturation.perso && (
                                        <Row>
                                            <Form.Item
                                                label={t`Prénom`}
                                                name="prenom"
                                                rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                                style={{marginRight: 20}}
                                            >
                                                <Input placeholder={t`Prénom`}/>
                                            </Form.Item>

                                            <Form.Item
                                                label={t`Nom`}
                                                name="nom"
                                                rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                            >
                                                <Input placeholder={t`Nom`}/>
                                            </Form.Item>
                                        </Row>
                                    )}


                                    {!this.state.facturation.perso && (
                                        <Row>
                                            <Form.Item
                                                label={t`Raison Sociale`}
                                                name="raison"
                                                rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                                style={{marginRight: 20}}
                                            >
                                                <Input placeholder={t`Raison Sociale`}/>
                                            </Form.Item>

                                            <Form.Item
                                                label={t`SIREN`}
                                                name="siren"
                                                rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                            >
                                                <Input placeholder={t`SIREN`}/>
                                            </Form.Item>
                                        </Row>
                                    )}


                                    <Form.Item
                                        label={t`Adresse`}
                                        name="adresse"
                                        rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                    >
                                        <Input placeholder={t`Adresse`}/>
                                    </Form.Item>

                                    <Row>
                                        <Form.Item
                                            label={t`Code Postal`}
                                            name="postal"
                                            rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                            style={{marginRight: 20}}
                                        >
                                            <Input placeholder={t`Code Postal`}/>
                                        </Form.Item>

                                        <Form.Item
                                            label={t`Ville`}
                                            name="ville"
                                            rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                            style={{marginRight: 20}}
                                        >
                                            <Input placeholder={t`Ville`}/>
                                        </Form.Item>

                                        <Form.Item
                                            label={t`Pays`}
                                            name="pays"
                                            rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                        >
                                            <Select showSearch placeholder={t`Pays`} style={{minWidth:200}}>
                                                {COUNTRY.map(i=>{
                                                    return(
                                                        <Select.Option value={i.country}>{i.country}</Select.Option>
                                                    )
                                                })}
                                            </Select>
                                        </Form.Item>
                                    </Row>


                                    <Form.Item style={{display: "flex", justifyContent: "flex-end"}}>
                                        <Button type="primary" htmlType="submit" loading={this.state.loading}>
                                            <Trans>Valider</Trans>
                                        </Button>
                                    </Form.Item>
                                </Form>

                            </div>
                        )}

                        {this.state.step == 1 && (
                            <div style={{
                                margin: "50px 0px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}>
                                <Form.Item
                                    label={t`Raison du Paiement`}
                                    name="raison"
                                    rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                >
                                    <Select showSearch filterOption={(input, option) => {
                                        var text = option.props.children
                                        if (Array.isArray(text)) {
                                            text = text.join("")
                                        }
                                        return text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }} style={{width: 500, maxWidth: "80vw"}} placeholder={t`Raison du Paiement`}
                                            onChange={(value) => {
                                                const item = this.state.types.find(i => i.value == value)
                                                this.setState({step: 2, type: item},()=>this.onFinish())
                                            }}>
                                        {this.getFilteredTypes(this.state.types).map((item, index) => {
                                            return <Option key={index} value={item.value}>{translateLivretType(item,true)}</Option>
                                        })}
                                    </Select>
                                </Form.Item>
                            </div>
                        )}
                    </PermissionAlert>
                </Modal>
            </Fragment>


        )
    }
}

const mapStateToProps = (state) => {
    return {
        org: state.auth.org
    }
}

export default connect(mapStateToProps)(ModalBasePaiement)
